/*************************************************/
/* MODAL                                         */
/*************************************************/
import customEventsNames from './../customEventsNames';
export function modal(body, bodyLoadingClass) {
    let modals = Array.from(document.querySelectorAll('.modal')),
        modalDialogClassSelector = '.modal-dialog',
        modalContentClassSelector = '.modal-content',
        modalCloseButtonClassSelector = '.modal-close',
        utils;
    const mainContentSelector = '#mainContent',
        modalPlayerId = 'modalplayer',
        modalShowClass = 'modal--show';
    let triggerElement = null;

    const init = function () {
        modalUtils();

        modals.forEach(modal => {
            modal.addEventListener(customEventsNames.openModal, e => {
                if (e.detail.videoElement) {
                    utils.Video.AddVideoToModal(e.detail.modalId, e.detail.videoElement);
                } else if (e.detail.modalId && e.detail.videoId) {
                    utils.Video.AddYoutubeVideoToModal(e.detail.modalId, e.detail.videoId);
                } else if (e.detail.modalId && e.detail.vimeoUrl) {
                    utils.Video.AddVimeoToModal(e.detail.modalId, e.detail.vimeoUrl);
                }
            });

            modal.addEventListener(customEventsNames.videoPlayingInModal, e => {
                body.classList.remove(bodyLoadingClass);
            });

            //Close if background is clicked, but not if modalDialog is clicked
            modal.addEventListener('click', e => {
                utils.Modal.CloseModal(e.target.getAttribute('id'));
            });

            const dialog = modal.querySelector(modalDialogClassSelector);
            dialog.addEventListener('click', e => {
                e.stopPropagation();
                e.preventDefault();
            });

            modal.querySelector(modalCloseButtonClassSelector).addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                utils.Modal.CloseModal(e.target.closest('.modal').getAttribute('id'));
            });
        });


    };

    function modalUtils() {
        if (!utils) {
            utils = {
            };
        }

        if (modals.length > 0) {
            utils.Modal = {
                OpenModal(modalId, content) {
                    triggerElement = document.activeElement;
                    const modal = document.querySelector(modalId);
                    body.classList.add('noscroll');
                    modal.classList.add(modalShowClass);
                    modal.querySelector(modalContentClassSelector).appendChild(content);

                    document.querySelector(mainContentSelector).setAttribute('aria-hidden', true);

                    setTimeout(() => {
                        modal.focus();
                    }, 300); //Timeout here to compensate for the transition on the modal

                },
                CloseModal(modalId, clearContent = true) {
                    modalId = `#${modalId}`;
                    const modal = document.querySelector(modalId);
                    modal.classList.remove(modalShowClass);
                    if (clearContent = true) {
                        const content = modal.querySelector(modalContentClassSelector);
                        content.removeChild(content.querySelector('#' + modalPlayerId));
                    }
                    body.classList.remove('noscroll', bodyLoadingClass);

                    const closeModalEvent = new CustomEvent(customEventsNames.closeModal, { bubbles: true });
                    modal.dispatchEvent(closeModalEvent);

                    document.querySelector(mainContentSelector).setAttribute('aria-hidden', false);

                    setTimeout(() => {
                        triggerElement.focus();
                    }, 200); //Timeout here to compensate for the keyup event needing to finish


                }
            };
        }

        utils.Video = {
            AddYoutubeVideoToModal(modalId, videoId) {
                const player = document.createElement('div');
                player.id = modalPlayerId;
                utils.Modal.OpenModal(modalId, player);
                body.classList.add(bodyLoadingClass);

                var playYoutubeVideoEvent = new CustomEvent(customEventsNames.playYoutubeVideoInModal, {
                    bubbles: true,
                    detail: {
                        modalId: modalId,
                        playerId: modalPlayerId,
                        videoId: videoId
                    }
                });

                player.dispatchEvent(playYoutubeVideoEvent);
            },
            AddVideoToModal(modalId, videoElement) {
                videoElement.id = modalPlayerId;

                utils.Modal.OpenModal(modalId, videoElement);

                body.classList.add(bodyLoadingClass);

                var playVideoEvent = new CustomEvent(customEventsNames.playVideoInModal, {
                    bubbles: true,
                    detail: {
                        modalId: modalId,
                        playerId: modalPlayerId
                    }
                });
                videoElement.dispatchEvent(playVideoEvent);

            },
            AddVimeoToModal(modalId, vimeoUrl) {
                const player = document.createElement('div');
                player.id = modalPlayerId;
                utils.Modal.OpenModal(modalId, player);
                body.classList.add(bodyLoadingClass);
                var playVimeoVideoEvent = new CustomEvent(customEventsNames.playVimeoInModal, {
                    bubbles: true,
                    detail: {
                        modalId: modalId,
                        playerId: modalPlayerId,
                        vimeoUrl: vimeoUrl
                    }
                });

                player.dispatchEvent(playVimeoVideoEvent);
            }
        };
    }

    init();
}